import { createTheme } from '@mui/material/styles';

const PURPLE = '#a259c6';

export const theme = createTheme({
  // CSS variables let the canvas panel and MUI share the same tokens, and avoid
  // a flash of the wrong colours before hydration.
  cssVariables: true,
  palette: {
    mode: 'dark',
    primary: { main: PURPLE, contrastText: '#ffffff' },
    secondary: { main: '#7ef9ff' },
    background: { default: '#14121f', paper: '#1e1b2e' },
    text: { primary: '#f2eefb', secondary: '#b3abc9' },
    divider: 'rgba(162, 89, 198, 0.24)',
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: ['Pretendard', '"Noto Sans KR"', 'system-ui', 'sans-serif'].join(','),
    // MUI's default base is 14px. Every variant is derived from this, so raising
    // it scales labels, inputs and captions together rather than one by one.
    fontSize: 15,
    h1: { fontSize: 'clamp(1.5rem, 1.1rem + 1.8vw, 2.25rem)', fontWeight: 800, letterSpacing: '-0.02em' },
    button: { textTransform: 'none', fontWeight: 700 },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
      },
    },
    MuiAccordion: {
      defaultProps: { disableGutters: true, elevation: 0, square: false },
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          border: '1px solid rgba(162, 89, 198, 0.24)',
          borderRadius: 12,
          '&::before': { display: 'none' },
          '& + &': { marginTop: 8 },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: { minHeight: 52 },
        content: { margin: '12px 0' },
      },
    },
    MuiTextField: { defaultProps: { size: 'small' } },
    MuiSelect: { defaultProps: { size: 'small' } },
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiSlider: {
      styleOverrides: {
        root: { '@media (pointer: coarse)': { padding: '16px 0' } },
      },
    },
    // A visible focus ring everywhere, not just where the browser decides.
    MuiCssBaseline: {
      styleOverrides: {
        ':focus-visible': { outline: `2px solid ${PURPLE}`, outlineOffset: 2 },
      },
    },
  },
});
